const PixellWelcomeEmail = () => {
  return (
    <div
      style={{
        backgroundColor: "#f5f5f5",
        fontFamily: "Arial, sans-serif",
        padding: "0",
        margin: "0",
      }}
    >
      <table
        width="100%"
        cellPadding="0"
        cellSpacing="0"
        border="0"
        bgcolor="#f5f5f5"
        style={{ width: "100%", borderCollapse: "collapse" }}
      >
        <tbody>
          <tr>
            <td align="center">
              {/* Main Container */}
              <table
                width="600"
                cellPadding="0"
                cellSpacing="0"
                border="0"
                bgcolor="#ffffff"
                style={{
                  borderRadius: "8px",
                  overflow: "hidden",
                  marginTop: "30px",
                }}
              >
                {/* Logo */}
                <tbody>
                  <tr>
                    <td align="center" style={{ padding: "30px 0 20px 0" }}>
                      <img
                        src="https://pixelldasboardbucket.s3.ap-south-1.amazonaws.com/PixellLogo.png"
                        alt="Pixell Logo"
                        width="100"
                        style={{ display: "block" }}
                      />
                    </td>
                  </tr>

                  {/* Banner */}
                  <tr>
                    <td>
                      <img
                        src="https://pixelldasboardbucket.s3.ap-south-1.amazonaws.com/PixellBanner.png"
                        alt="Pixell Banner"
                        width="600"
                        style={{ display: "block", maxWidth: "100%" }}
                      />
                    </td>
                  </tr>

                  {/* Content */}
                  <tr>
                    <td
                      style={{
                        padding: "30px",
                        color: "#333333",
                        fontSize: "15px",
                        lineHeight: "1.6",
                      }}
                    >
                      <p
                        style={{
                          margin: "0 0 15px 0",
                          fontSize: "18px",
                          fontWeight: "bold",
                        }}
                      >
                        Hi Ankit,
                      </p>

                      <p style={{ margin: "0 0 15px 0" }}>
                        We’re delighted to have you onboard.
                      </p>

                      <p style={{ margin: "0 0 15px 0" }}>
                        Pixell is the world’s first tech-enabled retail branding
                        execution platform, designed to bring unmatched
                        transparency, speed, and control to your branding
                        rollouts. From site surveys to installation, everything
                        is now at your fingertips—intuitively tracked and
                        managed in real time.
                      </p>

                      <p style={{ margin: "0 0 15px 0" }}>
                        To ensure you have a seamless experience, We are
                        assigning a dedicated Client Servicing Executive. His
                        contact details are as follows:
                      </p>

                      <p style={{ margin: "0 0 15px 0", fontWeight: "bold" }}>
                        <img
                          src="https://cdn-icons-png.flaticon.com/512/847/847969.png"
                          alt="Person"
                          width="16"
                          height="16"
                          style={{
                            verticalAlign: "middle",
                            marginRight: "5px",
                          }}
                        />
                        Mahesh Narwat
                        <br />
                        <img
                          src="https://cdn-icons-png.flaticon.com/512/724/724664.png"
                          alt="Phone"
                          width="16"
                          height="16"
                          style={{
                            verticalAlign: "middle",
                            marginRight: "5px",
                          }}
                        />
                        9220605718
                        <br />
                        <img
                          src="https://cdn-icons-png.flaticon.com/512/732/732200.png"
                          alt="Email"
                          width="16"
                          height="16"
                          style={{
                            verticalAlign: "middle",
                            marginRight: "5px",
                          }}
                        />
                        mahesh@pixell.in
                      </p>

                      <p style={{ margin: "0 0 15px 0" }}>
                        Please feel free to reach out to him for any
                        assistance—you’ll find him closely supporting you at
                        every step.
                      </p>

                      <p style={{ margin: "0 0 25px 0" }}>
                        To get started, we recommend taking a few moments to
                        explore our platform and familiarize yourself with our
                        features. From our informative dashboard to our robust
                        location updates system, we’ve designed our platform to
                        be as user-friendly as possible.
                      </p>

                      {/* Button */}
                      <p
                        style={{
                          textAlign: "center",
                          marginBottom: "30px",
                        }}
                      >
                        <a
                          href="https://pixell.in/user"
                          style={{
                            backgroundColor: "#418CFF",
                            color: "#ffffff",
                            textDecoration: "none",
                            padding: "12px 30px",
                            borderRadius: "6px",
                            fontWeight: "bold",
                            display: "inline-block",
                          }}
                        >
                          Login to your account
                        </a>
                      </p>

                      <p style={{ margin: "0 0 10px 0" }}>
                        Thank you for choosing Pixell. We look forward to seeing
                        you have a great experience with us.
                      </p>

                      <p style={{ margin: "0" }}>
                        Best Regards,
                        <br />
                        <strong>Team Pixell</strong>
                      </p>
                    </td>
                  </tr>

                  {/* Social Icons */}
                  {/* <tr>
                    <td align="center" style={{ padding: "20px 0" }}>
                      <a href="#" style={{ margin: "0 8px" }}>
                        <img
                          src="https://pixelldasboardbucket.s3.ap-south-1.amazonaws.com/instagram.png"
                          alt="Instagram"
                          width="24"
                          style={{ display: "inline-block" }}
                        />
                      </a>
                      <a href="#" style={{ margin: "0 8px" }}>
                        <img
                          src="https://pixelldasboardbucket.s3.ap-south-1.amazonaws.com/facebook.png"
                          alt="Facebook"
                          width="24"
                          style={{ display: "inline-block" }}
                        />
                      </a>
                    </td>
                  </tr> */}

                  {/* Footer */}
                  <tr>
                    <td
                      style={{
                        padding: "20px",
                        fontSize: "12px",
                        color: "#888888",
                        textAlign: "center",
                        backgroundColor: "#f9f9f9",
                      }}
                    >
                      © 2025 pixell. All rights reserved.
                      {/* <a
                        href="#"
                        style={{
                          color: "#888888",
                          textDecoration: "underline",
                        }}
                      >
                        Privacy policy
                      </a>{" "}
                      •{" "}
                      <a
                        href="#"
                        style={{
                          color: "#888888",
                          textDecoration: "underline",
                        }}
                      >
                        Terms of service
                      </a>{" "}
                      •{" "}
                      <a
                        href="#"
                        style={{
                          color: "#888888",
                          textDecoration: "underline",
                        }}
                      >
                        Unsubscribe
                      </a> */}
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default PixellWelcomeEmail;
